<template>
  <form @submit.prevent="submitAddress">
    <button
      type="button"
      class="btn btn-default btn-xs pull-right"
      @click.prevent="addNewAddress"
      id="new-address-vue"
    >
      {{ labels[1144] }}
    </button>
    <!-- label: enter a new address -->

    <h3>
      {{ labels[1051] }}
      <!-- Select a shipping address: -->
    </h3>

    <div class="item-head" v-if="showAddressFilter">
      <select
        id="addressfilterVue"
        v-model="filterAddressType"
        class="w30"
        @change="addressFilterTypeChange"
      >
        <option value="STATE">
          {{ labels[1052] }}
          <!-- Filter By State -->
        </option>
        <option value="CITY">
          {{ labels[1053] }}
          <!-- Filter By City -->
        </option>
        <option value="POSTAL">
          {{ labels[1054] }}
          <!-- Filter By Zip -->
        </option>
      </select>
      <input
        id="add-filter-text-vue"
        type="text"
        v-model="filterAddressVal"
        class="w60"
        :placeholder="addFilterPlaceholder"
      />
    </div>

    <Checkout-Address-Options
      :address-options="filteredAddresses"
      :address-count="customerAddresses.length"
      :mode="mode"
    />
    <div class="infoText small text-right" v-html="optionInfoMsg"></div>
  </form>
</template>

<script>
  import { ref, computed, watch } from '@vue/composition-api'
  import useCMS from '../../shared/composables/useCMS'
  import useCheckout from '../composables/useCheckout'
  import useCheckoutAddresses from '../composables/useCheckoutAddresses'
  import CheckoutAddressOptions from '../components/CheckoutAddressOptions.vue'

  export default {
    name: 'CheckoutAddressSelector',
    components: {
      CheckoutAddressOptions,
    },
    props: {
      mode: String, //shipping, billing
    },
    setup(props) {
      const { labels, getDynamicMessage } = useCMS()
      const { checkoutUser } = useCheckout()
      const {
        getCustAddresses,
        editingAddress,
        newAddress,
        customerAddresses,
      } = useCheckoutAddresses()
      const addressLimit = 15
      const showAddressFilter = computed(() => customerAddresses.value.length > addressLimit)

      const removeNewAddressInShipping = (addressArray) => {
        return addressArray.filter(function(address) {
          return props.mode == 'billing' || address.ID != 100000000000000020000
        })
      }

      const filteredAddresses = computed(() => {
        if (customerAddresses.value.length > addressLimit) {
          if (filterAddressVal.value != '') {
            return removeNewAddressInShipping(
              customerAddresses.value.filter(function(address) {
                return (
                  address[filterAddressType.value] == undefined ||
                  address[filterAddressType.value].search(filterAddressVal.value) >= 0
                )
              })
            )
          } else {
            var addCopy = Array.from(customerAddresses.value)
            addCopy.length = addressLimit
            return removeNewAddressInShipping(addCopy)
          }
        }
        return removeNewAddressInShipping(customerAddresses.value)
      })

      const optionInfoMsg = ref('')
      const getAddrCountMessage = () => {
        getDynamicMessage(8, {
          displayCount: filteredAddresses.value.length,
          totalCount: customerAddresses.value.length,
        }).then((resp) => {
          if (resp.status == 200) {
            optionInfoMsg.value = resp.data
          }
        })
      }

      const {
        filterAddressVal,
        addressFilterTypeChange,
        addFilterPlaceholder,
        filterAddressType,
      } = useAddressFilter(filteredAddresses, customerAddresses, getAddrCountMessage)

      const addNewAddress = () => {
        editingAddress.value = true
        newAddress(props.mode)
      }

      getCustAddresses(
        checkoutUser.value.custInfo.contact.iid,
        checkoutUser.value.custInfo.customer.primary.iid,
        props.mode
      )

      return {
        labels,
        addressFilterTypeChange,
        showAddressFilter,
        addFilterPlaceholder,
        filterAddressType,
        filterAddressVal,
        customerAddresses,
        addNewAddress,
        optionInfoMsg,
        filteredAddresses,
      }
    },
  }

  function useAddressFilter(filteredAddresses, customerAddresses, getAddrCountMessage) {
    const { labels } = useCMS()

    watch(filteredAddresses, () => {
      getAddrCountMessage()
    })

    const filterAddressType = ref('STATE')
    const addFilterPlaceholder = ref(labels[1055])

    const addressFilterTypeChange = () => {
      if (filterAddressType.value != 'STATE') {
        addFilterPlaceholder.value = labels[1059] //label: Enter text to filter
      } else {
        addFilterPlaceholder.value = labels[1055] //label: Filter by State Code
      }
    }

    const filterAddressVal = ref('')

    return {
      filterAddressVal,
      addressFilterTypeChange,
      addFilterPlaceholder,
      filterAddressType,
    }
  }
</script>
